// payment.stats.dto.ts
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const paymentStatsSchema = z.object({
  total: z.number(),
  pending: z.number(),
  buyed: z.number(),
  canceled: z.number(),
  totalAmount: z.number(),
  averageAmount: z.number(),
});

export class PaymentStatsDto extends createZodDto(paymentStatsSchema) {}

export const revenueByRateSchema = z.array(
  z.object({
    rateId: z.string(),
    rateName: z.string(),
    total: z.number(),
    count: z.number(),
  }),
);

export class RevenueByRateDto extends createZodDto(revenueByRateSchema) {}

export const revenueByMonthSchema = z.array(
  z.object({
    month: z.number().min(1).max(12),
    total: z.number(),
  }),
);

export class RevenueByMonthDto extends createZodDto(revenueByMonthSchema) {}
